import React from 'react';
import { Row, Col } from 'react-bootstrap';

function RequestHeader(props) {

    return (
        <>
            <Row  >
                <Col>
                    &nbsp;
                </Col>
            </Row>
            <Row className='border-top' >
                <Col>Reference Number : <b>{props.rhdata.req_refno}</b></Col>
                <Col>Branch : <b>{props.rhdata.req_brnno + ' : ' + props.rhdata.req_brnnm}</b></Col>
                <Col>Reference : <b>{props.rhdata.req_type === "S" ? "Branch" : "Agent"}</b></Col>
                <Col>Agent : {
                    props.rhdata.req_agentno * 1 === 0 ? null : <>
                        <b>{props.rhdata.req_agentno + ' : ' + props.rhdata.req_agentnm + ' ' + props.rhdata.mel_location}</b>
                    </>
                }
                </Col>
            </Row>
            {
                props.rhdata.req_bankrefno === "" ?
                    <></> : <>
                        <Row>
                            <Col>
                                Bank Reference : <b>{props.rhdata.req_bankrefno}</b>
                            </Col>
                            <Col>&nbsp;</Col>
                            <Col>&nbsp;</Col>
                            <Col>&nbsp;</Col>
                        </Row>
                    </>
            }
            <Row >
                <Col>
                    &nbsp;
                </Col>
            </Row >
            <Row>
                <Col>Remitter Type : <b>{props.rhdata.req_remittertype === "I" ? "Individual" : "Corporate"}</b></Col>
                <Col>Remitter Name : <b>{props.rhdata.req_remittername}</b></Col>
                <Col>PAN : {props?.rhdata?.mpr_rel_name && <b>{props.rhdata.mpr_rel_name} : {props.rhdata.req_pan}</b>}</Col>
                <Col>Name on Pan : <b>{props.rhdata.req_nameonpan}</b></Col>
            </Row>
            <Row >
                <Col>
                    &nbsp;
                </Col>
            </Row >
            <Row >
                <Col>Purpose: <b>{props.rhdata.req_purpose + ' : ' + props.rhdata.req_purposenm}</b></Col>
                <Col>Serial Number : <b>{props.rhdata.req_srno}</b></Col>
                <Col>Product : <b>{props.rhdata.req_productcode}</b></Col>
                <Col>&nbsp;</Col>
            </Row>
            <Row>
                <Col>
                    &nbsp;
                </Col>
            </Row>
            <Row >
                <Col>Currency: <b>{props.rhdata.req_isd} ({props.rhdata.req_tenure})</b></Col>
                <Col>Quantity: <b>{props.rhdata.req_quantity}</b></Col>
                <Col>Sell Rate: <b>{props.rhdata.req_sellrate}</b></Col>
                <Col>Forex INR : <b>{(props.rhdata.req_sellrate * props.rhdata.req_quantity).toFixed(2)}</b> </Col>
            </Row>
            <Row>
                <Col>
                    &nbsp;
                </Col>
            </Row>

            <Row >
                {
                    /*
                        String(props.rhdata.req_valuedate).split('-').reverse().join('/')
                    */
                }
                <Col>Email : <b>{props.rhdata.req_email}</b></Col>
                <Col>Mobile : <b>{props.rhdata.req_mobile}</b></Col>
                <Col>Nostro Type : <b>{props.rhdata.req_nostrotype}</b></Col>
                <Col>BANK : {
                    props.rhdata.req_bank * 1 === 0 ? null :
                        <>
                            <b>{props.rhdata.req_bank + ' : ' + props.rhdata.req_banknm}</b>
                        </>
                }
                </Col>

            </Row>
            <Row>
                <Col>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col>ITR 2 Years: <b>{props.rhdata.req_itr2year === 1 ? "Yes" : "No"}</b></Col>
                <Col>Source of Fund: <b>{props.rhdata.req_sourceoffund === "S" ? "Self" : "Loan"}</b></Col>
                {
                    props.rhdata.req_sourceoffund === "L" ? <>
                        <Col>Disbursed Institute: <b>{props.rhdata.req_disbinstname}</b></Col>
                        <Col>Disbursed Amount: <b>{props.rhdata.req_disbamount}</b></Col>
                    </> : <>
                        <Col>&nbsp;</Col><Col>&nbsp;</Col>
                    </>
                }
            </Row>

            <Row >
                <Col>
                    &nbsp;
                </Col>
            </Row >
            <Row>
                <Col xs={12}>Remark: <b>{props.rhdata.req_rmk}</b></Col>
            </Row>
            <Row>
                <Col xs={12}>Remark: <b>{props.rhdata.req_rmk1}</b></Col>
            </Row>
            <Row>
                <Col xs={12}>Remark: <b>{props.rhdata.req_rmk2}</b></Col>
            </Row>
            <Row className='border-top'>
                <Col>
                    &nbsp;
                </Col>
            </Row >
        </>
    )
}
export default RequestHeader;